/*
 * @Author: zhenglfsir@gmail.com
 * @Date: 2018-11-29 14:15:29
 * @Last Modified by: zhenglfsir@gmail.com
 * @Last Modified time: 2018-11-29 21:37:26
 * 控制区域
 */
import * as React from 'react';
import { render } from 'react-dom';
import { Icon } from 'antd';
import styles from './index.less';
import { withDefaultProps } from '../../Hoc/withDefaultProps';

export interface IContextMenuItem {
  title: string;
  key: string;
  icon?: string;
}

const defaultProps = {
  menus: [] as IContextMenuItem[],
  style: {} as React.CSSProperties,
  way: 'single' as 'unknown' | 'single',
};

type DefaultProps = typeof defaultProps;
type Props = DefaultProps & {
  onMenuClick: (menu: IContextMenuItem, data: any, target: HTMLElement) => void;
  data: any;
} & Partial<{
    children: React.ReactInstance;
  }>;

class ContextMenuCmp extends React.Component<Props> {
  body = document.body;
  container: HTMLDivElement | null = null;

  componentDidMount() {
    this.body.addEventListener('click', this.handleRemove);
    this.body.addEventListener('contextmenu', this.handleRemove);
  }

  componentWillUnmount() {
    this.body.removeEventListener('click', this.handleRemove);
    this.body.removeEventListener('contextmenu', this.handleRemove);
  }

  render() {
    const { children, style } = this.props;
    return (
      <div
        className={styles.controllerArea}
        onContextMenu={this.handleContextMenu}
        style={{ ...style }}
      >
        {children}
      </div>
    );
  }

  handleRemove = () => {
    if (this.container) {
      this.body.removeChild(this.container);
      this.container = null;
    }
  };

  handleContextMenuItem = (item: IContextMenuItem, target: HTMLElement) => {
    return () => {
      const { data, onMenuClick } = this.props;
      if (onMenuClick) onMenuClick(item, data, target);
    };
  };

  handleContextMenu = (event: React.MouseEvent<HTMLDivElement>) => {
    if (!this.props.menus.length) return;
    let target = event.target as HTMLElement;
    const { way, menus } = this.props;
    let usedableMenu = menus;
    if (way === 'unknown') {
      if (!target.dataset.contextMenu) {
        const dom = target.children[0] as HTMLElement;
        if (!dom || !dom.dataset || !dom.dataset.contextMenu) {
          return;
        }
        target = dom;
      }
      if (target.dataset.contextMenu && typeof target.dataset.contextMenu === 'string') {
        const contextMenus = target.dataset.contextMenu.split('/');
        usedableMenu = usedableMenu.filter((item) => contextMenus.includes(item.key));
      }
    }
    event.preventDefault();
    if (!this.container) {
      this.container = document.createElement('div');
      this.container.className = styles.controllerMenus;
      this.body.appendChild(this.container);
    }
    this.container.style.top = event.clientY + 'px';
    this.container.style.left = event.clientX + 'px';
    render(
      <ul className={styles.menus}>
        {usedableMenu.map((item) => (
          <li key={item.key} onClick={this.handleContextMenuItem(item, target)}>
            {item.icon ? (
              <span className={styles.icons}>
                <Icon type={item.icon} />
              </span>
            ) : null}
            {item.title}
          </li>
        ))}
      </ul>,
      this.container
    );
  };
}

export const ContextMenu = withDefaultProps<Props>(defaultProps, ContextMenuCmp);
